// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3YaNN","upload":"Small_upload__1vRWE","imageWrap":"Small_imageWrap__2aRzk","removeBtn":"Small_removeBtn__3dhaE"};